import { createContext, useContext, useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("almox_token");
      if (!token) { setUser(false); setLoading(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("almox_token");
        setUser(false);
      } finally { setLoading(false); }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("almox_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("almox_token");
    setUser(false);
  };

  const can = (...roles) => {
    if (!user) return false;
    if (user.role === "ADMINISTRADOR") return true;
    return roles.includes(user.role);
  };

  const canFinance = user && (user.role === "ADMINISTRADOR" || user.role === "COMPRAS");

  const hasModule = (code) => {
    if (!user) return false;
    if (user.is_platform_admin) return true;
    if (user.enabled_modules == null) return true;
    return user.enabled_modules.includes(code);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, canFinance, hasModule, apiErr }}>
      {children}
    </AuthContext.Provider>
  );
}
